import { ContentChild, Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "williams-ui-platform-dropdown-templates"
})
export class DropdownTemplateDirective {
  @ContentChild('dropdownListItemTemplate') dropdownListItemTemplate!: TemplateRef<any>;
  @ContentChild('dropdownListValueTemplate') dropdownListValueTemplate!: TemplateRef<any>; 
}